<template>
    <!-- Read-only dates summary for the sticky desktop panel. The ONE editable
         date control is the "Desired dates" field in the form; this only reflects
         the selection and links back to it. No pricing is computed here (price
         anchors render statically in the panel). Renders nothing when there are no
         dates, or in any non-panel placement (mobile shows a night-count line
         under the fields instead). -->
    <div
        v-if="variant === 'panel' && hasDates"
        class="space-y-1"
    >
        <p class="label label-small">
            Your dates
        </p>
        <p class="text-xsss font-semibold text-brand-2-950">
            {{ summary }}
        </p>
        <button
            type="button"
            class="text-link text-xssss"
            @click="focusDates"
        >
            Change dates
        </button>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    import { enquiryDates, formatDateRangeSummary } from '@js/src/stores/enquiryDates';

    const props = defineProps({
        // Retained for backwards compatibility with the existing tag; unused now
        // that no live pricing is fetched.
        propertyId: {
            type: [Number, String],
            default: '',
        },
        // 'panel' → render the full summary + Change dates shortcut. Anything else
        // renders nothing (the mobile summary is a night-count line in the form).
        variant: {
            type: String,
            default: '',
        },
    });

    const hasDates = computed(() => Boolean(enquiryDates.from && enquiryDates.to));
    const summary = computed(() => formatDateRangeSummary(enquiryDates.from, enquiryDates.to));

    // Scroll to the single editable dates field and open its picker — the panel
    // summary is a shortcut, not a second control.
    function focusDates() {
        const field = document.getElementById('enquiry-dates');
        if (!field) return;

        field.scrollIntoView({ behavior: 'smooth', block: 'center' });

        const trigger = field.querySelector('.select-filter');
        if (trigger) {
            setTimeout(() => trigger.click(), 350);
        }
    }
</script>
